export default __webpack_public_path__ + "static/media/bj1.e1280269.jpg";